import { Link } from "react-router-dom";
import logo from "../resources/mutfaciknewlogo.png";
import { LEGAL_PATHS } from "../legal/legalContent";

const SOCIAL_LINKS = [
  { icon: "bi-instagram", href: "https://instagram.com/mutfacik", label: "Instagram" },
];

const NAV_LINKS = [
  { label: "Hakkımızda", href: "#" },
  { label: "İletişim", href: "#" },
  { label: "Gizlilik Politikası", href: LEGAL_PATHS.privacy },
  { label: "Kullanım Koşulları", href: LEGAL_PATHS.terms },
  { label: "Hesap Silme", href: LEGAL_PATHS.accountDeletion },
];

function Footer() {
  return (
    <footer style={{ background: "#111827", color: "#9ca3af" }}>
      <div className="container py-5">
        <div className="row g-4 align-items-start">

          {/* Marka */}
          <div className="col-12 col-md-4">
            <img src={logo} alt="mutfacık" style={{ height: "36px", filter: "brightness(0) invert(1)" }} />
            <p className="mt-3 small" style={{ lineHeight: 1.7, maxWidth: "280px" }}>
              Kuzey Kıbrıs'ın en sevilen restoranlarından lezzetleri kapınıza getiriyoruz.
            </p>
            <div className="d-flex gap-2 mt-3">
              {SOCIAL_LINKS.map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    background: "#1f2937",
                    border: "1px solid #374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9ca3af",
                    textDecoration: "none",
                    transition: "background 0.2s, color 0.2s, border-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "#c20e1a";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#fff";
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = "#c20e1a";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "#1f2937";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#9ca3af";
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = "#374151";
                  }}
                >
                  <i className={`bi ${icon}`} style={{ fontSize: "1rem" }} />
                </a>
              ))}
            </div>
          </div>

          {/* Bağlantılar */}
          <div className="col-6 col-md-3 offset-md-2">
            <h6 className="fw-semibold mb-3" style={{ color: "#f9fafb", letterSpacing: "0.05em", fontSize: "0.8rem", textTransform: "uppercase" }}>
              Bağlantılar
            </h6>
            <ul className="list-unstyled m-0">
              {NAV_LINKS.map(({ label, href }) => (
                <li key={label} className="mb-2">
                  <Link
                    to={href}
                    style={{ color: "#9ca3af", textDecoration: "none", fontSize: "0.9rem", transition: "color 0.2s" }}
                    onMouseEnter={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = "#c20e1a")}
                    onMouseLeave={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = "#9ca3af")}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim */}
          <div className="col-6 col-md-3">
            <h6 className="fw-semibold mb-3" style={{ color: "#f9fafb", letterSpacing: "0.05em", fontSize: "0.8rem", textTransform: "uppercase" }}>
              İletişim
            </h6>
            <ul className="list-unstyled m-0 small">
              <li className="mb-2 d-flex align-items-start gap-2">
                <i className="bi bi-envelope-fill mt-1" style={{ color: "#c20e1a", flexShrink: 0 }} />
                <span>support@mutfacik.com</span>
              </li>
              <li className="mb-2 d-flex align-items-start gap-2">
                <i className="bi bi-telephone-fill mt-1" style={{ color: "#c20e1a", flexShrink: 0 }} />
                <span>+90 533 871 29 02</span>
              </li>
              <li className="d-flex align-items-start gap-2">
                <i className="bi bi-geo-alt-fill mt-1" style={{ color: "#c20e1a", flexShrink: 0 }} />
                <span>Lefkoşa, Kuzey Kıbrıs</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Alt çizgi */}
        <div
          className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 mt-5 pt-4"
          style={{ borderTop: "1px solid #1f2937", fontSize: "0.8rem" }}
        >
          <span>© {new Date().getFullYear()} mutfacık. Tüm hakları saklıdır.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
